import { connect, MapDispatchToProps, MapStateToProps, MergeProps } from "react-redux";

import { getSecondaryText } from "@multiweb/reactCore/i18n";
import { IconCode } from "@multiweb/types/contracts";
import { IAppState } from "@multiweb/types/react";
import { createMenuItemActivatedAction } from "../../actions";
import { LOC_KEY_ACTION_ITEM_CLOSE } from "../../locKeys";
import { createActionItemFocusedAction, createFocusableItemId, isItemFocused, MenuFocusableItemType, NavigationSection } from "../../navigation";
import { ActionItemHoverType, MenuItemActivatedType } from "../../types";
import { createMenuItemKeyActivationHandler, createMenuItemMouseActivationHandler } from "../../utils";
import { ActionItemComponent, ActionItemComponentProps } from "../ActionItemComponent";

export type CloseActionItemProps = {
    /** Identifikátor otevřené instance formuláře. */
    formInstanceId: string;
    /** Sekce, ve které je položka vykreslená. Slouží pro určování zaměření. */
    section: NavigationSection;
    /** Příznak, zda se má použít barva pozadí pro submenu. */
    hasSubmenuBackground?: boolean;
    /** Příznak, zda má tlačítko vypadat jako po najetí myši. */
    isActive?: boolean;
};

type StateProps = {
    title: string | undefined;
    isFocused: boolean;
};

type DispatchProps = {
    actionActivated: typeof createMenuItemActivatedAction;
    actionItemFocused: typeof createActionItemFocusedAction;
};

const mapStateToProps: MapStateToProps<StateProps, CloseActionItemProps, IAppState> = (state, { formInstanceId, section }) => ({
    title: getSecondaryText(state, LOC_KEY_ACTION_ITEM_CLOSE),
    isFocused: isItemFocused(state, { itemId: formInstanceId, type: MenuFocusableItemType.closeActionItem, section }),
});

const mapDispatchToProps: MapDispatchToProps<DispatchProps, CloseActionItemProps> = ({
    actionActivated: createMenuItemActivatedAction,
    actionItemFocused: createActionItemFocusedAction,
});

const mergeProps: MergeProps<StateProps, DispatchProps, CloseActionItemProps, ActionItemComponentProps> = (
    { title, isFocused },
    { actionActivated, actionItemFocused },
    { formInstanceId, isActive, hasSubmenuBackground, section },
) => ({
    title,
    onClick: createMenuItemMouseActivationHandler(formInstanceId, MenuItemActivatedType.closeActionItem, section, actionActivated),
    onKeyUp: createMenuItemKeyActivationHandler(formInstanceId, MenuItemActivatedType.closeActionItem, section, actionActivated),
    iconCode: IconCode.uiCrossSmall,
    isActive,
    hasSubmenuBackground,
    hoverType: ActionItemHoverType.danger,
    isFocused,
    actionItemFocused: () => actionItemFocused(createFocusableItemId(formInstanceId, MenuFocusableItemType.closeActionItem, section)),
});

/**
 * ActionItem pro zavření formuláře.
 */
export const CloseActionItem = connect(mapStateToProps, mapDispatchToProps, mergeProps)(ActionItemComponent);
